import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import ErrorBoundary from '@copilot/common/components/containers/errorBoundary';

export type BaseModalProps = ModalProps;

// TODO Update to use useModal in antv5 instead of BaseModal
export type BaseModalWithIdProps = BaseModalProps & {
    modalId: string;
};

export function BaseModal({ children, ...rest }: BaseModalProps) {
    return (
        <Modal {...rest}>
            <ErrorBoundary>{children}</ErrorBoundary>
        </Modal>
    );
}
